"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasExcursionIncompleteData = void 0;
const hasExcursionIncompleteData = (excursion) => {
    const invalidSections = [];
    if (!excursion?.seo?.title)
        invalidSections.push("SEO Title");
    if (!excursion?.seo?.description)
        invalidSections.push("SEO Description");
    if (!excursion?.seo?.keywords)
        invalidSections.push("SEO Keywords");
    if (!excursion?.seo?.canonical)
        invalidSections.push("SEO Canonical");
    if (!excursion?.transfer_area_id)
        invalidSections.push("Transfer Area");
    if (!excursion?.excursion_type)
        invalidSections.push("Excursion Type");
    if (!excursion?.location_name)
        invalidSections.push("Location Name");
    if (!excursion?.location_type)
        invalidSections.push("Location Type");
    if (!excursion?.full_address)
        invalidSections.push("Address");
    if (!excursion?.longitude)
        invalidSections.push("Longitude");
    if (!excursion?.latitude)
        invalidSections.push("Latitude");
    return invalidSections;
};
exports.hasExcursionIncompleteData = hasExcursionIncompleteData;
